export default function Shipping() {
  return (
    <div data-testid="page-shipping" className="max-w-[1000px] mx-auto px-5 md:px-10 py-16">
      <p className="overline mb-3">Policies</p>
      <h1 className="font-display text-5xl md:text-7xl mb-12">Shipping & Returns.</h1>
      <div className="space-y-10 text-white/75 leading-relaxed">
        <section>
          <h2 className="font-display text-2xl md:text-3xl mb-3 text-white">Shipping</h2>
          <p>All apparel is produced on-demand by our Printify partners and ships from the closest print centre. Standard delivery times worldwide are 5–12 business days after production. Original artworks, prints & panels ship from our Etsy studio in Australia, generally within 3–10 business days.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl md:text-3xl mb-3 text-white">Returns</h2>
          <p>We accept returns on apparel within 30 days if items are unworn, unwashed, and in original condition. Custom commissions, digital downloads and hand-painted originals are final sale unless there's a fulfillment defect. If your parcel arrives damaged, contact us within 7 days and we'll make it right.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl md:text-3xl mb-3 text-white">Taxes & duties</h2>
          <p>International customers may be responsible for local import duties or GST/VAT on delivery — please check your country's rules.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl md:text-3xl mb-3 text-white">Contact</h2>
          <p>Need help with an order? Email <a className="text-[#FF4500]" href="mailto:hello@camskooriart.com">hello@camskooriart.com</a> — we reply within 2 business days.</p>
        </section>
      </div>
    </div>
  );
}
